import { useQuery } from "@tanstack/react-query";

import { getPortfolio } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;

export interface UsePortfolioParams {
	worksiteId: string | undefined;
	referenceDate: string;
	enabled?: boolean;
}

export function usePortfolio({
	worksiteId,
	referenceDate,
	enabled = true,
}: UsePortfolioParams) {
	return useQuery({
		queryKey: chartKeys.portfolio(worksiteId, referenceDate),
		queryFn: () =>
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			getPortfolio(worksiteId!, { referenceDate }),
		enabled: enabled && !!worksiteId,
		staleTime: STALE_TIME,
	});
}
